import coverImg from "assets/images/v134/cover.webp"
import titleImg from "assets/images/v134/title.webp"

export const v134Config = {
  cover: {
    en: coverImg,
  },
  title: {
    en: titleImg,
  },
}
